import { Injectable } from '@angular/core';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Arabic } from '../../../../public/i18n/ar';
import { English } from '../../../../public/i18n/en';
import { APP_NAME } from '../../environment';
import { Router } from '@angular/router'; 
import { GlobalService } from './global.service';


@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  currentLanguage: string | null = "ar";
  labelsApp: any;
  direction: any = 'rtl'
  defaultLanguage = "ar"

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router, 
    public global: GlobalService,
  ) { }

  handleLanguage() {
    this.currentLanguage = this?.router?.url?.includes('/ar') ? 'ar' : 'en' ;
    this.global.languageCode = this.currentLanguage;

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(APP_NAME + 'language', this.currentLanguage);
      this.initiateLanguage(this.currentLanguage);
    }
    if (isPlatformServer(this.platformId)) {
      this.initiateLanguage(this.currentLanguage);
    }
  }

  initiateLanguage(language: string) { 
    this.labelsApp = this.getLabelsApp(this.currentLanguage);
  }

  getLabelsApp(language: string) { 
    return this.labelsApp = (language == 'en' ? English : Arabic);
  }

  // @ts-ignore
  translate = (label: string): string => { 
    if (isPlatformBrowser(this.platformId)) {
      return this.labelsApp[label] ? this.labelsApp[label] : label;
    } 
    if (isPlatformServer(this.platformId)) {
      return this.labelsApp[label] ? this.labelsApp[label] : label;
    }
  }

}



